import { AllEndUserData } from '@components/members/components/allEndUserList';
import { APICONFIG } from '@config/api.config';
import { IQueryResponse } from '@services/api';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';

type AllEndUserQuery = {
	data: AllEndUserData[];
	error: Error | null;
	isLoading: boolean;
	isPending: boolean;
};

export const useSearchAllEndUserQuery = (
	search: string | number,
	is_ob_meet: boolean = false
): IQueryResponse<AllEndUserQuery[]> => {
	const fetchAllUserData = async (): Promise<AllEndUserQuery[]> => {
		return APIService.getData<AllEndUserQuery[]>(`${APICONFIG.ALL_END_USER_API}`, {
			limit: '0',
			is_ob_meet,
			search,
		});
	};

	const { data, error, isLoading, isPending, refetch, isFetching } = useQuery({
		queryKey: ['EndUser', is_ob_meet, search],
		queryFn: fetchAllUserData,
		enabled: false,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		refetch,
		isFetching,
	};
};
